import { AxiosResponse } from 'axios';
import { AppThunk } from 'store';

import { OrderStatus } from 'types/enums/OrderStatus';

import { getDeclineTypeTestCookie } from 'helpers/payment/helpers';
import { assertString } from 'helpers/utils/checkType';

import {
  setOneClickPaymentCardToken,
  setOneClickPaymentDeclineType,
  setOneClickPaymentOrderId,
  setOneClickPaymentStatus,
  setOneClickPaymentVerifyUrl,
} from './oneClickPaymentSlice';

function resolvePayResult(data: any): AppThunk {
  return function resolvePayResultInner(dispatch) {
    if (data?.order?.status === OrderStatus.Success) {
      dispatch(setOneClickPaymentStatus(OrderStatus.Success));
    } else if (data?.order?.status === OrderStatus.Error) {
      dispatch(setOneClickPaymentStatus(OrderStatus.Error));

      if (assertString(data?.verify_url)) {
        dispatch(setOneClickPaymentVerifyUrl(data.verify_url));
      }

      const testDeclineType = getDeclineTypeTestCookie();
      if (testDeclineType) {
        dispatch(setOneClickPaymentDeclineType(testDeclineType));
      } else {
        dispatch(setOneClickPaymentDeclineType(data.order?.decline_type));
      }
    } else if (data?.order?.status === OrderStatus.Process) {
      dispatch(setOneClickPaymentStatus(OrderStatus.Process));
    }
  };
}

export function microOneClickPay(payload: {
  packId: string;
  cardToken: string;
  payFn: (payload: {
    packId: string;
    cardToken: string;
  }) => Promise<AxiosResponse<any>>;
}): AppThunk {
  return async function oneClickPayInner(dispatch) {
    try {
      const { data } = await payload.payFn({
        packId: payload.packId,
        cardToken: payload.cardToken,
      });

      dispatch(setOneClickPaymentCardToken(data?.order?.card?.id ?? null));
      dispatch(resolvePayResult(data));
      dispatch(setOneClickPaymentOrderId(data?.order?.id));
    } catch (err) {
      dispatch(setOneClickPaymentStatus(OrderStatus.Error));
      console.error('[microOneClickPay]: ', err);
    }
  };
}

export function microOneClickPayResign(payload: {
  cardToken: string;
  cvv: string;
  packId: string;
  payFn: (payload: {
    packId: string;
    cardToken: string;
    cvv: string;
  }) => Promise<AxiosResponse<any>>;
}): AppThunk {
  return async function oneClickPayInner(dispatch) {
    try {
      const { data } = await payload.payFn(payload);

      resolvePayResult(data);
      dispatch(setOneClickPaymentOrderId(data?.order?.id));
    } catch (err) {
      dispatch(setOneClickPaymentStatus(OrderStatus.Error));
      console.error('[microOneClickPayResign]: ', err);
    }
  };
}
